import PropTypes from 'prop-types'
import clsx from 'clsx'
import { NavLink, Link as RouterLink } from 'react-router-dom'
import {
  AppBar as MuiAppbar,
  Box,
  Button,
  IconButton,
  Link,
  Toolbar,
  Tooltip,
  Typography,
  useMediaQuery,
} from '@mui/material'
import { useTheme } from '@mui/material/styles'

import { ReactComponent as SignOut } from '../../../assets/icons/sign-out.svg'
import { ReactComponent as TextAlignRight } from '../../../assets/icons/text-align-right.svg'
import { ReactComponent as X } from '../../../assets/icons/x.svg'
import { ReactComponent as User } from '../../../assets/icons/user-circle.svg'

import * as routes from '../../../routes'
import useTranslations from '../../../i18n/useTranslations'

import Logo from '../../../assets/images/ctt-logo.svg'
import Avatar from '../../../ui/components/avatar'
import LanguageSelector from '../../../ui/components/LanguageSelector'

import useStyles from './styles'

const AppBar = ({ userName, email, onLogout, isOpen, onToggleMenu }) => {
  const classes = useStyles()
  const t = useTranslations()

  const theme = useTheme()
  const isSmUp = useMediaQuery(theme.breakpoints.up('sm'))

  return (
    <MuiAppbar
      position="fixed"
      className={clsx(classes.appBar, {
        [classes.appBarShift]: isOpen,
      })}
    >
      <Toolbar className={classes.toolbar}>
        <Box className={classes.leftGroup}>
          <LanguageSelector />
          <RouterLink to={routes.USER_ZONE.linkTo()}>
            <Button className={classes.userButton} variant="text">
              {/* <Avatar
              className={classes.userAvatar}
              size="smaller"
              userName={userName}
              email={email}
            /> */}
              <User className={classes.userIcon} />
              {t('noun:account')}
            </Button>
          </RouterLink>
        </Box>
        {isSmUp ? null : (
          <Link underline="none" component={NavLink} to={routes.HOME.linkTo()}>
            <img src={Logo} alt="" className={classes.logo} />
          </Link>
        )}

        <Box>
          {isSmUp ? (
            <Tooltip
              title={
                <Typography variant="body2">{t('action:logout')}</Typography>
              }
              placement="top-start"
            >
              <IconButton onClick={onLogout} size="large">
                <SignOut />
              </IconButton>
            </Tooltip>
          ) : (
            <IconButton onClick={onToggleMenu} size="large">
              {isOpen ? <X /> : <TextAlignRight />}
            </IconButton>
          )}
        </Box>
      </Toolbar>
    </MuiAppbar>
  )
}

AppBar.propTypes = {
  userName: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  onLogout: PropTypes.func,
  isOpen: PropTypes.bool,
  onToggleMenu: PropTypes.func,
}

export default AppBar
